module.exports = {
	"header": "Spotin partners with authors and book publishers",
	"date": "2022/11/17",
	"imgSrc": "Spotin_x_Books.jpg",
	"imgAlt": "Spotin partners with authors and book publishers",
	"ingress": "The tech company Spotin continues to make e-commerce friction free for books category. It has partnered with some more authors like ‘Matilda Westerman’ and ‘Anders Södergård’, also an illustrator ‘Filippa Widlund’ and the organization ‘Make Equal’ to sell books with Spotin’s content commerce technology. They will use Spotin's service to sell books, which are published by Bonnierförlagen.",
	"sections": [
		{
			"paragraphs": [
				"Spotin enables friction-free commerce on any 3<sup>rd</sup>-party website, app, or platform, without links or redirections. The tech company wants to democratize the e-com industry, bringing the power back to content creators and sellers, and an opportunity for both to work in profit and synergy. Now the authors Matilda Westerman and Anders Södergård, the illustrator Filippa Widlund and the organization Make Equal will offer an opportunity to purchase books on their website, from within images, content, and in a Spotin enabled e-shop. All these will have a friction-free shopping experience i.e., product discovery of books and complete purchase check-out, all in one spot, without any links or re-directions. These shopping experiences will be further optimized for exposure and traffic on social media by the respective author or content creator partner."
			],
			"quote": {
				"text": "“Spotin stands behind the technology that makes our book shoppable from within the content of our own website - even though it’s Bonnierförlagen who is the selling party. We are happy that we can sell our book on our own website! We get all the pros of having an online shop, without the hassle of having an online shop.”",
				"author": "Ida Östensson",
				"title": "Chairman of Make Equal"
			}
		},
		{
			"quote": {
				"text": "“To sell your own products via your own digital media is trending. We are proud of the collaboration we have with Bonnierförlagen, which enables authors, organizations etc, to sell their books on their own sites with Spotin.”",
				"author": "Kristoffer Karlsson",
				"title": "Founder and CEO of Spotin."
			}
		},
		{
			"paragraphs": [
				"<br><strong>Have a look at some examples of Spotin on these sites here:</strong>",
				"<a href='https://www.okejmeddig.nu/#/sp?p=43828&v=610029' style='text-decoration: underline;'>'Okej med dig?' book at Make Equal</a>",
				"<a href='https://www.filippawidlund.com/#/sp?s=1' style='text-decoration: underline;'>Filippa Widlund's shop</a>"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/13/article.json
// module id = 11
// module chunks = 0